import { render, staticRenderFns } from "./SharePageModal.vue?vue&type=template&id=1dc41cd0&scoped=true"
import script from "./SharePageModal.vue?vue&type=script&lang=js"
export * from "./SharePageModal.vue?vue&type=script&lang=js"
import style0 from "./SharePageModal.vue?vue&type=style&index=0&id=1dc41cd0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dc41cd0",
  null
  
)

export default component.exports